import {makeKey,update} from '../../../../utils/reducerOperations';
export function fileUploadStarted(state, payload) {
    return makeKey(
        'uploadSurveyApi',
        update(state.uploadSurveyApi, {
            isProcessing: true
        })
    );
}